import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Asset, InvestmentMasterAppraisalValue } from "../../all_Interfaces";


interface InitialState {
    data: InvestmentMasterAppraisalValue,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as InvestmentMasterAppraisalValue,
    error: '',
    loading: false
}

const investmentAppraisalSlice = createSlice({
    name: "investmentAppraisal",
    initialState,
    reducers: {
        updateInvestmentAppraisal(state, action: PayloadAction<InvestmentMasterAppraisalValue>) {
            state.data = action.payload;
        },
    },
});

export const { updateInvestmentAppraisal } = investmentAppraisalSlice.actions;

export default investmentAppraisalSlice.reducer;